import React, { useMemo } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Link } from "react-router-dom";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

// Monta um documento HTML completo com o CSS do editor + o mesmo Bootstrap
// carregado no canvas do GrapesJS. Sem isso, o preview aparece sem estilos.
const buildPreviewDoc = (html, css) => `
  <!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" />
      <link rel="stylesheet" href="https://unpkg.com/spectre.css/dist/spectre.min.css" />
      <style>
        html, body { margin: 0; padding: 0; background: #fff; width: 100%; }
        /* Força containers do Bootstrap a ocuparem 100% da largura no preview */
        .container,
        .container-sm,
        .container-md,
        .container-lg,
        .container-xl,
        .container-xxl {
          max-width: 100% !important;
          width: 100% !important;
        }
        ${css || ""}
      </style>
    </head>
    <body>${html || ""}</body>
  </html>
`;

function ModalPreview(args) {
  const srcDoc = useMemo(
    () =>
      buildPreviewDoc(
        args.template?.htmlString,
        args.template?.htmlJson,
      ),
    [args.template?.htmlString, args.template?.htmlJson],
  );

  return (
    <div className="modal_setter">
      <Modal isOpen={args.modal} toggle={args.toggle} {...args}>
        <ModalHeader toggle={args.toggle}>Pré-visualização</ModalHeader>
        <ModalBody
          style={{ overflow: "hidden", padding: 0, margin: 0, width: "100%" }}
        >
          <iframe
            title="Pré-visualização do template"
            id="serviceFrameSend"
            className="frame-fill"
            srcDoc={srcDoc}
            style={{
              width: "100%",
              height: 500,
              border: "none",
              display: "block",
            }}
            scrolling="yes"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={args.toggle}>
            Fechar
          </Button>
          <Link
            to={args.internal ? "/event/templates" : "/html-editor"}
            state={{
              ...args.location,
              type_template: args.template.type,
              editMode: true,
              template: args.template,
            }}
          >
            <ButtonSpinner title="Editar Template" size={120} action="U" />
          </Link>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ModalPreview;
